import { render, staticRenderFns } from "./obligationYC.vue?vue&type=template&id=60512866&scoped=true"
import script from "./obligationYC.vue?vue&type=script&lang=js"
export * from "./obligationYC.vue?vue&type=script&lang=js"
import style0 from "./obligationYC.vue?vue&type=style&index=0&id=60512866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60512866",
  null
  
)

export default component.exports